import { __assign, __awaiter, __generator } from "tslib";
import { KnownInstrumentationEvents, } from '@office-start/instrumentation-types';
import { getRequestIdFromResponse, httpPatch } from '@office-start/xhr-service';
import { getGraphServiceEndpoint } from '../utilities/getGraphServiceEndpoint';
/**
 * Rename a OneDrive/Sharepoint drive item by PATCH request
 * Ref: https://learn.microsoft.com/en-us/graph/api/driveitem-update?view=graph-rest-1.0&tabs=http
 * @param driveId Drive id where item lives
 * @param itemId Id of the item
 * @param graphXhrOptions Parameters needed to create a web request
 * @param patchedItem Partial object containing properties to be updated
 * @param queryParams Additional query parameter, such as <'select', 'id,content.downloadUrl'> or format <'format', 'PDF'>
 * @returns Promise with a GraphDriveItem
 * */
export function patchDriveItem(_a) {
    var driveId = _a.driveId, itemId = _a.itemId, graphXhrOptions = _a.graphXhrOptions, patchedItem = _a.patchedItem, queryParams = _a.queryParams;
    return __awaiter(this, void 0, void 0, function () {
        var apiPath, url, requestConfig;
        return __generator(this, function (_b) {
            apiPath = "drives/".concat(driveId, "/items/").concat(itemId);
            url = getGraphServiceEndpoint(graphXhrOptions.graphApiRoot, apiPath, false, queryParams);
            requestConfig = {
                method: "PATCH" /* HttpRequestMethod.Patch */,
                headers: {
                    'Content-Type': 'application/json',
                },
            };
            return [2 /*return*/, httpPatch(KnownInstrumentationEvents.OneDriveGraphPatchItemRequest, "OneDrive_Graph_Patch_Item" /* KnownRequestInstrumentationEvents.OneDriveGraphPatchItemRequest */, url, patchedItem, requestConfig, graphXhrOptions.jwtAuthEnabled, graphXhrOptions.getAccessToken, graphXhrOptions.officeApiRoot, graphXhrOptions.correlationId, 'Graph', {
                    populateRequestEvent: function (response, params) {
                        params["RequestId" /* InstrumentationParam.RequestId */] =
                            getRequestIdFromResponse(response) || '';
                    },
                })
                    .then(function (response) {
                    if (!response || !response.ok || response.data === undefined) {
                        throw new Error((response === null || response === void 0 ? void 0 : response.statusText) || 'Graph API error');
                    }
                    return response.data;
                })
                    .catch(function (error) {
                    var _a, _b;
                    throw __assign(__assign({}, error), { clientError: (_b = (_a = error.httpResponse.data) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.code });
                })];
        });
    });
}
//# sourceMappingURL=patchDriveItem.js.map